import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RegisterOnboardingUploadMutationVariables = Types.Exact<{
  input: Types.RegisterOnboardingUploadInput;
}>;


export type RegisterOnboardingUploadMutation = { __typename?: 'Mutation', registerOnboardingUpload: { __typename?: 'OnboardingUploadRegistrationPayload', result?: { __typename?: 'OnboardingUploadRegistrationResult', jobId: string, sourceId: string, sourceVersion: number, outcome: Types.OnboardingJourneyRecordOutcome } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartOrResumeOnboardingJourneyMutationVariables = Types.Exact<{
  input: Types.StartOrResumeOnboardingJourneyInput;
}>;


export type StartOrResumeOnboardingJourneyMutation = { __typename?: 'Mutation', startOrResumeOnboardingJourney: { __typename?: 'OnboardingJourneyStartPayload', result?: { __typename?: 'OnboardingJourneyStartResult', journeyId: string, outcome: Types.OnboardingJourneyResolution } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SnoozeOnboardingWelcomeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SnoozeOnboardingWelcomeMutation = { __typename?: 'Mutation', snoozeOnboardingWelcome: { __typename?: 'OnboardingWelcomePreferencePayload', preference?: { __typename?: 'OnboardingWelcomePreference', snoozedUntil?: Types.TDateISO | null, isSnoozed: boolean, isDismissed: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DismissOnboardingWelcomeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DismissOnboardingWelcomeMutation = { __typename?: 'Mutation', dismissOnboardingWelcome: { __typename?: 'OnboardingWelcomePreferencePayload', preference?: { __typename?: 'OnboardingWelcomePreference', snoozedUntil?: Types.TDateISO | null, isSnoozed: boolean, isDismissed: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RegisterOnboardingUploadDocument = new TypedDocumentString(`
    mutation RegisterOnboardingUpload($input: RegisterOnboardingUploadInput!) {
  registerOnboardingUpload(input: $input) {
    result {
      jobId
      sourceId
      sourceVersion
      outcome
    }
    errors {
      code
      message
    }
  }
}
    `);
export const StartOrResumeOnboardingJourneyDocument = new TypedDocumentString(`
    mutation StartOrResumeOnboardingJourney($input: StartOrResumeOnboardingJourneyInput!) {
  startOrResumeOnboardingJourney(input: $input) {
    result {
      journeyId
      outcome
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SnoozeOnboardingWelcomeDocument = new TypedDocumentString(`
    mutation SnoozeOnboardingWelcome {
  snoozeOnboardingWelcome {
    preference {
      ...OnboardingWelcomePreference
    }
    errors {
      code
      message
    }
  }
}
    fragment OnboardingWelcomePreference on OnboardingWelcomePreference {
  snoozedUntil
  isSnoozed
  isDismissed
}`);
export const DismissOnboardingWelcomeDocument = new TypedDocumentString(`
    mutation DismissOnboardingWelcome {
  dismissOnboardingWelcome {
    preference {
      ...OnboardingWelcomePreference
    }
    errors {
      code
      message
    }
  }
}
    fragment OnboardingWelcomePreference on OnboardingWelcomePreference {
  snoozedUntil
  isSnoozed
  isDismissed
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RegisterOnboardingUpload: build.mutation<RegisterOnboardingUploadMutation, RegisterOnboardingUploadMutationVariables>({
      query: (variables) => ({ document: RegisterOnboardingUploadDocument, variables })
    }),
    StartOrResumeOnboardingJourney: build.mutation<StartOrResumeOnboardingJourneyMutation, StartOrResumeOnboardingJourneyMutationVariables>({
      query: (variables) => ({ document: StartOrResumeOnboardingJourneyDocument, variables })
    }),
    SnoozeOnboardingWelcome: build.mutation<SnoozeOnboardingWelcomeMutation, SnoozeOnboardingWelcomeMutationVariables | void>({
      query: (variables) => ({ document: SnoozeOnboardingWelcomeDocument, variables })
    }),
    DismissOnboardingWelcome: build.mutation<DismissOnboardingWelcomeMutation, DismissOnboardingWelcomeMutationVariables | void>({
      query: (variables) => ({ document: DismissOnboardingWelcomeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRegisterOnboardingUploadMutation, useStartOrResumeOnboardingJourneyMutation, useSnoozeOnboardingWelcomeMutation, useDismissOnboardingWelcomeMutation } = injectedRtkApi;
